export default "assets/images/logo-cca62e64.jpg";